// fetch('https://api.ipregistry.co/?key=tryout')
//     .then(function (response) {
//         return response.json();
//     })
//     .then(function (payloads) {
//         console.log(payloads.location.country.name + ', ' + payloads.location.city);
//     }); 

// fetch('/search/collections/'+collection.handle+'?q=chocolate+2+'&ajax=true').then(res => res.text()).then(res => {
//           $('.template-collection').find('.product-grid').html(res);
//         });

$('a.hash-link.goto_top').click(function(){

    $("html, body").animate({ scrollTop: 0 }, "slow");
  return false;
})
$("form#search_Product").submit(function(e) {
e.preventDefault();
  
 var getval= $('form#search_Product input').val();
   var geturl= $('form#search_Product').attr('currentColection');
    
  var fulUrl=geturl+'/'+getval;
    console.log(fulUrl)
  
$.ajax({
  url: fulUrl, 
  type:"GET",
  success: function(result){
      var gethtml=$(result).find('.product-list.product-grid.row.grid').html();
    if(gethtml){
      $('.product-list.product-grid.row.grid').html(gethtml);
    }else{
    
    $('.product-list.product-grid.row.grid').html('<p>Sorry, there are no products in this collection</p>')
    
    }
    }
    
   
  })
 
})
$('.target--tabs h3').click(function(){
  if($(this).hasClass('active')){
  $(this).removeClass('active');
  $('.data--grid--tabs').slideUp();
  }else{
  
  
$('.target--tabs h3').removeClass('active');
$(this).addClass('active');
    $('.data--grid--tabs').slideUp();
  $(this).next('.data--grid--tabs').slideDown();
  
  }

})

$('.search--icon-grid.icon--rows-g a').click(function(e){

e.preventDefault();
  console.log('test');
  $('form.main-search__form.mob-search').toggleClass('active');
})
$('footer#page-footer .links-column.column li.compare--list a').click(function(e){
  e.preventDefault();

$('#ptt-compare-sticky')[0].click();

})
function swymCallbackFn() {
    // your API calls go here
    //over ride the swym cart api to support custom slider cart 
    var replayAddToCartOriginalFn = _swat.replayAddToCart;
    window._swat.replayAddToCart = function() {
      //save the successCallback
      var successCallbackFn = arguments[2];
      arguments[2] = function(data) {
        if (successCallbackFn && updateThirdPartyCartFn) {
          successCallbackFn(data);
          updateThirdPartyCartFn(data);
        };
      }
      //call the orginal fn
      replayAddToCartOriginalFn.apply(this, arguments);
    };
    //runs on success callback.
    function updateThirdPartyCartFn(productData) {
      // Successfully added to cart API, Now call your slider cart here.
      console.log("Trigger your cart update here ");
      window.location.href='/pages/swym-wishlist'
    }
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);